module.exports = "/_next/static/images/VesselForecast-d9e17c7aea767098731d81fcb081ff2c.svg";